import { Component, Input } from '@angular/core';
import { Navigator } from 'src/app/services/routing/navigator';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';

@Component({
  selector: 'app-withdrawal-reverse-confirm',
  templateUrl: './withdrawal-reverse-confirm.component.html',
  styleUrls: ['./withdrawal-reverse-confirm.component.scss'],
})
export class WithdrawalReverseConfirmComponent extends WithdrawalBaseComponent {
    @Input() navigateBackPage: string;
    @Input() payoutRequestID: number;
    @Input() amount: string;

    public error = null;

    constructor(
        private withdrawService:WithdrawalService,
        public successMessageService:SuccessMessageService,
        private navigator:Navigator
    ) {
        super();
    }

  onReverseWithdraw() {
        const requestObj: any = {};
        requestObj.payoutRequestID = this.payoutRequestID;
        
        this.withdrawService.callReverseWithdrawal(requestObj).subscribe({
            next: (response: any) => {
                if (response && !!response.result ) {
                    this.successMessageService.setMessage('Your withdrawal was successfully reversed.');
                    // this.balanceProvider.updateBalance();
                }
            },
            error: (error) => {
                // handle all deposit errors in base
                this.error = this.handleError(error);
            }
        })

        this.error = null;
    }

    onBack = () => {
        if (this.navigateBackPage) {
            this.navigator.navigateTo(this.navigateBackPage);
        } else {
            this.navigator.back();
        }
    }
}
